import React from 'react';
import { Dropdown } from 'antd';
import getPopupContainer from '../../Hooks/getPopupContainer';
import { DropDownProps as DropDownCopyProps } from 'antd/lib/dropdown';

export type DropDownProps = DropDownCopyProps;

const ProDropdown: React.FC<DropDownProps> = (props) => {
  const { children, ...resProps } = props;
  return (
    <Dropdown getPopupContainer={getPopupContainer} {...resProps}>
      {children}
    </Dropdown>
  );
};

export default ProDropdown;
